import styled from 'styled-components'

export const ButtonHistory = styled.div`
  min-height: 50px;
  display: flex;
  justify-content: ${props => props.fontAlignement ? props.fontAlignement : "center"};
  align-items: center;
  padding: 0 20px;
  background-color: ${({ backgroundColor }) => backgroundColor ? backgroundColor : "#FFF"};
  color: ${({labelColor}) => labelColor ? labelColor : "#000000"};
  font-weight: ${({labelWeight}) => labelWeight ? labelWeight : "bold"};
  font-size: ${({labelSize}) => labelSize ? labelSize : "13px"};
  border-radius: ${props => props.borderRadius && props.activeRadius ? props.borderRadius : "5px"};
  border-style: ${props => props.borderStyle && props.isActive ? props.borderStyle : props.isActive && "solid"};
  border-color: ${props => props.borderColor && props.isActive ? props.borderColor : props.isActive && "#000"};
  border-width: ${props => props.borderSize && props.isActive ? props.borderSize : props.isActive && "0px"};
  cursor: pointer;
  transition: 0.2s;
`

export const Link = styled.a`
  min-height: 50px;
  display: flex;
  justify-content: ${props => props.fontAlignement ? props.fontAlignement : "center"};
  align-items: center;
  padding: 0 20px;
  background-color: ${({ backgroundColor }) => backgroundColor ? backgroundColor : "#FFF"};
  color: ${({labelColor}) => labelColor ? labelColor : "#000000"};
  font-weight: ${({labelWeight}) => labelWeight ? labelWeight : "bold"};
  font-size: ${({labelSize}) => labelSize ? labelSize : "13px"};
  border-radius: ${props => props.borderRadius && props.activeRadius ? props.borderRadius : "5px"};
  border-style: ${props => props.borderStyle && props.isActive ? props.borderStyle : props.isActive && "solid"};
  border-color: ${props => props.borderColor && props.isActive ? props.borderColor : props.isActive && "#000"};
  border-width: ${props => props.borderSize && props.isActive ? props.borderSize : props.isActive && "0px"};
  cursor: pointer;
  transition: 0.2s;
`

export const IconContainer = styled.div`
  margin-right: ${({label, iconAlignement}) => label && iconAlignement === "left" ? "20px" : ""};
  margin-left: ${({label, iconAlignement}) => label && iconAlignement === "right" ? "20px" : ""};
`
